import { useMemo } from 'react';

import { accountCountColDef, descriptionColDef, nameColDef } from '../columns';
import type { TraitListColDef } from '../TraitList.model';

export const useCreateColDefs = (): TraitListColDef[] => {
  return useMemo(() => [nameColDef, descriptionColDef, accountCountColDef], []);
};
